import App from 'app/app.js';

function LtEnhancedPayOnlySummaryCtrl($scope, $timeout, $window) {
  this.packageItemViews = $scope.packageItemViews;

  this.init = function () {
    $timeout(function () {
      if ($scope.isScrollable) {
        $('#sticky').stickyfloat({
          duration: 0,
          offsetY: 0,
          parent: $('#auto-scroll')
        });
      }
    });
  };

  this.isSheetsToReturn = function () {
    return R.any(R.propEq('selected', false))(this.packageItemViews);
  };

  this.saveToCart = function () {
    $scope.onSaveToCart();
  };

  this.backToHome = function () {
    $scope.onBackToHome();
  };

  this.isNoItemSelected = function () {
    return !R.any(R.propEq('selected', true))(this.packageItemViews);
  };

  this.onContinue = function () {
    $window.scrollTo({ top: 0, behavior: 'smooth' });
    $scope.continueClick();
  };

  this.isEditPackage = function () {
    return !R.isNaN($scope.editIndex);
  };
}

App.controller('LtEnhancedPayOnlySummaryCtrl', ['$scope', '$timeout', '$window', LtEnhancedPayOnlySummaryCtrl]);
